import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TelPhoneIcon } from '../common/icon';
import { Drawer, Popover } from 'aha-components';
import DownloadAppQrImage from './DownloadAppQrImage';

export default function DownloadAppTextButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <Popover
        open={open}
        onOpenChange={setOpen}
        content={
          <div className="flex flex-col gap-[10px] w-[207px] p-1">
            <DownloadAppQrImage />
            <div className="justify-start text-[#79716B] text-sm font-medium font-['DM_Sans'] leading-5">
              {t('downloadAppTextButton.downloadStoresHint', {
                defaultValue: 'Download iOS / Android app'
              })}
            </div>
          </div>
        }
        placement="right"
        trigger="click"
        className="!hidden md:!block"
      >
        <div className="flex items-center gap-2 p-2 bg-[#FAFAF9] rounded-sm mt-3">
          <TelPhoneIcon />
          <div className="justify-start text-[#44403C] text-sm font-semibold font-['DM_Sans'] leading-5">
            {t('downloadAppTextButton.getOnMobile', {
              defaultValue: 'Get AhaCreator on mobile'
            })}
          </div>
        </div>
      </Popover>
      <div className="md:hidden">
        <div
          className="flex items-center gap-2 p-2 bg-[#FAFAF9] rounded-sm mt-3"
          onClick={() => setIsDrawerOpen(true)}
        >
          <TelPhoneIcon />
          <div className="justify-start text-[#44403C] text-sm font-semibold font-['DM_Sans'] leading-5">
            {t('downloadAppTextButton.getOnMobile', {
              defaultValue: 'Get AhaCreator on mobile'
            })}
          </div>
        </div>
        <Drawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          zIndex={1400}
          height="auto"
          placement="bottom"
          closable={false}
          drawerStyle={{
            borderRadius: '16px 16px 0 0',
            maxHeight: 'calc(100dvh - 16px)',
            overflow: 'hidden'
          }}
          bodyStyle={{
            padding: 0,
            flex: 'none',
            maxHeight: 'calc(100dvh - 16px)',
            overflowY: 'auto'
          }}
        >
          <div className="flex flex-col gap-[18px] py-[18px] items-center justify-center">
            <DownloadAppQrImage widthClassName="w-[195px]" />
            <div className="justify-start text-[#79716B] text-sm font-medium font-['DM_Sans'] leading-5">
              {t('downloadAppTextButton.downloadStoresHint', {
                defaultValue: 'Download iOS / Android app'
              })}
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
}
